import { HTTP_CP_Mortgage, HTTP_CP_UpdateMortgage_ForIrregularPayments_Request } from '@api-new/mortgageservice';
import { MortgageIrregularPaymentTypeModel } from '@platform/mortgage-detail/components/add-irregular-payment-dialog/models/mortgage-irregular-payment.model';

export const deleteIrregularPaymentFormToHttpRequestAdapter = (
  mortgage: HTTP_CP_Mortgage,
  mortgagePartId: string,
  irregularPaymentType: MortgageIrregularPaymentTypeModel,
  irregularPaymentId: string,
): HTTP_CP_UpdateMortgage_ForIrregularPayments_Request => {
  const mortgagePart = mortgage.mortgageParts.find((part) => part.id === mortgagePartId);
  return irregularPaymentType === 'overpayment'
    ? {
        mortgageId: mortgage.id,
        mortgagePartId,
        mortgagePartOverpayments: mortgagePart.mortgagePartOverpayments.filter((overpayment) => overpayment.id !== irregularPaymentId),
        mortgagePartUnderpayments: mortgagePart.mortgagePartUnderpayments,
      }
    : {
        mortgageId: mortgage.id,
        mortgagePartId,
        mortgagePartOverpayments: mortgagePart.mortgagePartOverpayments,
        mortgagePartUnderpayments: mortgagePart.mortgagePartUnderpayments.filter((underpayment) => underpayment.id !== irregularPaymentId),
      };
};
